import React from 'react';
import { OutstandingSuggestion } from '../outstandingSuggestions';
import { SuggestionExample } from './SuggestionExample';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Strong,
  Text,
} from 'components/core';
import { Stack } from 'components/layout';

// Naming every field makes for an unreadable wall of text on studies with many
// suggestions, so we name a few and count the rest.
const NAMED_FIELD_LIMIT = 3;

export const summariseFields = (
  outstanding: OutstandingSuggestion[]
): string => {
  const named = outstanding.slice(0, NAMED_FIELD_LIMIT).map((s) => s.label);
  const remaining = outstanding.length - named.length;

  return remaining > 0
    ? `${named.join(', ')}, + ${remaining} more`
    : named.join(', ');
};

export type OutstandingSuggestionsModalProps = {
  outstanding: OutstandingSuggestion[];
  onReviewSuggestions: () => void;
  onRejectAllAndComplete: () => void;
  onDismiss: () => void;
};

export const OutstandingSuggestionsModal = ({
  outstanding,
  onReviewSuggestions,
  onRejectAllAndComplete,
  onDismiss,
}: OutstandingSuggestionsModalProps) => (
  <Modal isOpen onClose={onDismiss}>
    <ModalHeader>Suggestions still need a decision</ModalHeader>
    <ModalBody>
      <Stack spacing={4}>
        <Text>
          To complete this study, each yellow-highlighted suggestion must be
          accepted (tick) or rejected (cross).
        </Text>
        <SuggestionExample />
        <div>
          <Text>
            <Strong>Fields with suggestions</Strong>
          </Text>
          <Text>{summariseFields(outstanding)}</Text>
        </div>
        <Text>
          Review suggestions individually or reject them all to complete.
        </Text>
      </Stack>
    </ModalBody>
    <ModalFooter>
      <Button type="neutral" variant="outline" onClick={onRejectAllAndComplete}>
        {`Reject all (${outstanding.length}) and complete`}
      </Button>
      <Button type="brand" onClick={onReviewSuggestions}>
        Review suggestions
      </Button>
    </ModalFooter>
  </Modal>
);
